// extracted by mini-css-extract-plugin
module.exports = {"header":"ImageGridHeader-module-header","title":"ImageGridHeader-module-title"};